import type { MatterDTO } from "@/api/types/matter";

/** A matter's visa type: its case's, else the individual's. */
export const visaOfMatter = (m: MatterDTO): string => {
  const fromCase = m.case?.visa;
  if (typeof fromCase === "string" && fromCase.trim()) return fromCase.trim();
  const ind = (m.individual ?? {}) as Record<string, unknown>;
  return typeof ind.visa === "string" ? ind.visa.trim() : "";
};

/** How many matters sit on each visa type, most first. */
export const countVisas = (
  matters: readonly MatterDTO[]
): Array<{ visa: string; count: number }> => {
  const byVisa = new Map<string, number>();
  for (const m of matters) {
    const visa = visaOfMatter(m);
    if (visa) byVisa.set(visa, (byVisa.get(visa) ?? 0) + 1);
  }
  return [...byVisa]
    .map(([visa, count]) => ({ visa, count }))
    .sort((a, b) => b.count - a.count);
};
